var oPreview = {
  currentIndex: 0,
  images: [],
  captions: [],
  postId: null,
  
  init: function () {
    $("body").on("click", ".imgPreview", function () {
      var clickedSrc = $(this).attr("data-img"),
        postId = $(this).attr("post-id");
      
      console.log("Opening gallery for post:", postId);
      
      // Zbierz wszystkie obrazki z galerii wraz z opisami
      oPreview.images = [];
      oPreview.captions = [];
      $(".imgPreview[post-id=" + postId + "]").each(function() {
        oPreview.images.push($(this).attr("data-img"));
        oPreview.captions.push({
          caption: $(this).attr("data-caption") || '',
          alt: $(this).attr("data-alt") || '',
          title: $(this).attr("data-title") || ''
        });
      });
      
      // Znajdź indeks klikniętego obrazka
      oPreview.currentIndex = oPreview.images.indexOf(clickedSrc);
      oPreview.postId = postId;
      
      console.log("Gallery has", oPreview.images.length, "images");
      console.log("Starting at index", oPreview.currentIndex);
      
      oPreview.showLightbox();
    });

    $("body").on("click", ".galleryPreviewClose", function () {
      oPreview.hideLightbox();
    });
    
    // Kliknięcie w tło zamyka lightbox
    $("body").on("click", ".galleryPreviewContainer", function (e) {
      if (e.target === this) {
        oPreview.hideLightbox();
      }
    });
    
    // Obsługa klawiatury
    $(document).on("keydown", function (e) {
      if ($(".galleryPreviewContainer").hasClass("hidden")) return;
      
      switch(e.keyCode) {
        case 27: // ESC
          oPreview.hideLightbox();
          break;
        case 37: // Left arrow
          oPreview.prevImage();
          break;
        case 39: // Right arrow
          oPreview.nextImage();
          break;
      }
    });
  },
  
  showLightbox: function() {
    var container = $(".galleryPreviewContainer[post-id=" + oPreview.postId + "]");
    var img = $(".galleryPreviewImg[post-id=" + oPreview.postId + "]");
    
    if (container.length === 0) {
      console.error("Lightbox container not found for post:", oPreview.postId);
      return;
    }
    
    // Ustaw obrazek i jego atrybuty
    var currentImage = oPreview.captions[oPreview.currentIndex];
    img.attr("src", oPreview.images[oPreview.currentIndex]);
    img.attr("alt", currentImage.alt);
    img.attr("title", currentImage.title);
    
    // Pokaż lightbox
    container.removeClass("hidden");
    $("body").addClass("overflow-hidden"); // Zablokuj scroll
    
    // Dodaj strzałki jeśli jest więcej niż 1 obrazek
    oPreview.updateNavigation();
    oPreview.updateCaption();
  },
  
  hideLightbox: function() {
    var container = $(".galleryPreviewContainer[post-id=" + oPreview.postId + "]");
    container.addClass("hidden");
    $("body").removeClass("overflow-hidden"); // Odblokuj scroll
  },
  
  nextImage: function() {
    if (oPreview.images.length <= 1) return;
    
    oPreview.currentIndex = (oPreview.currentIndex + 1) % oPreview.images.length;
    var img = $(".galleryPreviewImg[post-id=" + oPreview.postId + "]");
    var currentImage = oPreview.captions[oPreview.currentIndex];
    
    img.attr("src", oPreview.images[oPreview.currentIndex]);
    img.attr("alt", currentImage.alt);
    img.attr("title", currentImage.title);
    
    oPreview.updateNavigation();
    oPreview.updateCaption();
  },
  
  prevImage: function() {
    if (oPreview.images.length <= 1) return;
    
    oPreview.currentIndex = oPreview.currentIndex === 0 ? oPreview.images.length - 1 : oPreview.currentIndex - 1;
    var img = $(".galleryPreviewImg[post-id=" + oPreview.postId + "]");
    var currentImage = oPreview.captions[oPreview.currentIndex];
    
    img.attr("src", oPreview.images[oPreview.currentIndex]);
    img.attr("alt", currentImage.alt);
    img.attr("title", currentImage.title);
    
    oPreview.updateNavigation();
    oPreview.updateCaption();
  },
  
  updateNavigation: function() {
    var container = $(".galleryPreviewContainer[post-id=" + oPreview.postId + "]");
    
    // Usuń istniejące strzałki
    container.find(".gallery-nav").remove();
    
    console.log("Updating navigation for", oPreview.images.length, "images");
    
    if (oPreview.images.length > 1) {
      // Dodaj strzałki - używamy prostszych klas Tailwind
      var navHtml = 
        '<button class="gallery-nav gallery-prev" style="position: absolute; left: 20px; top: 50%; transform: translateY(-50%); background: rgba(0,0,0,0.7); color: white; border: none; border-radius: 50%; width: 50px; height: 50px; cursor: pointer; z-index: 10000; display: flex; align-items: center; justify-content: center;">' +
          '<svg style="width: 24px; height: 24px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>' +
          '</svg>' +
        '</button>' +
        '<button class="gallery-nav gallery-next" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%); background: rgba(0,0,0,0.7); color: white; border: none; border-radius: 50%; width: 50px; height: 50px; cursor: pointer; z-index: 10000; display: flex; align-items: center; justify-content: center;">' +
          '<svg style="width: 24px; height: 24px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>' +
          '</svg>' +
        '</button>' +
        '<div class="gallery-nav gallery-counter" style="position: absolute; bottom: 80px; left: 50%; transform: translateX(-50%); background: rgba(0,0,0,0.7); color: white; padding: 8px 16px; border-radius: 20px; font-size: 14px; z-index: 10000;">' +
          (oPreview.currentIndex + 1) + ' / ' + oPreview.images.length +
        '</div>';
      
      container.append(navHtml);
      
      console.log("Navigation added, buttons:", container.find(".gallery-nav").length);
      
      // Dodaj event listeners dla strzałek
      container.find(".gallery-prev").on("click", function(e) {
        e.stopPropagation();
        console.log("Previous button clicked");
        oPreview.prevImage();
      });
      
      container.find(".gallery-next").on("click", function(e) {
        e.stopPropagation();
        console.log("Next button clicked");
        oPreview.nextImage();
      });
    }
  },
  
  updateCaption: function() {
    var container = $(".galleryPreviewContainer[post-id=" + oPreview.postId + "]");
    var currentImage = oPreview.captions[oPreview.currentIndex];
    
    // Usuń istniejący caption
    container.find(".gallery-caption").remove();
    
    // Dodaj caption jeśli istnieje
    if (currentImage.caption && currentImage.caption.trim() !== '') {
      var captionHtml = 
        '<div class="gallery-caption" style="position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); background: rgba(0,0,0,0.8); color: white; padding: 12px 20px; border-radius: 8px; max-width: 80%; text-align: center; font-size: 14px; line-height: 1.4; z-index: 10001;">' +
          currentImage.caption +
        '</div>';
      
      container.append(captionHtml);
    }
  }
};

var oPost = {
  sel: {
    initPoint: ".start-load",
    postsContainer: ".async__posts",
    progressBar: ".progressBar",
    postBody: ".postBodyFlag",
  },

  options: {
    queryEnded: false,
    firstQueryEnded: false,
    currentPostId: "#initPostId",
    initPostCategory: "#initPostCategory",
    initPostLink: "#initPostLink",
    nextPostId: null,
    iterationCounter: 0,
    currentInViewport: null,
    wasInViewport: null,
    scrolled: false,
  },

  routes: {
    test: "/wp-json/",
    postById: "/wp-json/wp/v2/posts/",
  },

  urls: {},

  init: function () {
    console.log("init!");
    oPost.options.currentInViewport = $(oPost.options.currentPostId).val();

    $(window).scroll(function () {
      setTimeout(oPost.moveProgressBar(oPost.options.currentInViewport), 1);

      if ($.active > 0) {
        return true;
      } else {
        !oPost.options.firstQueryEnded
          ? oPost.checkBrakepoint($(oPost.options.currentPostId).val())
          : oPost.checkBrakepoint(oPost.options.currentPostId);
      }

      oPost
        .asyncFunction()
        .done(function () {
          oPost.checkViewport();
        })
        .fail(function () {
          console.log("oPost.checkViewport() Failed!");
        });
    });
  },

  checkBrakepoint: function (postId) {
    var initItem = $(oPost.sel.initPoint).offset().top,
      offset = initItem - $(window).scrollTop();

    if (2500 > offset && oPost.options.iterationCounter <= 2) {
      oPost.getPreviousPost(postId);
    }
  },

  getPreviousPost: function (postId) {
    $.ajax({
      method: "GET",
      url: oPost.routes.postById + postId,
      data: {
        scroll: "true",
        categories_exclude: "23",
      },
    })
      .done(function (response) {
        $(oPost.options.initPostLink).attr(
          "href",
          "#post__container__" + response.previous.id
        );
        oPost.urls[response.id] = response.link;

        response.previous != "" && response.previous != "undefined"
          ? (oPost.options.nextPostId = response.previous.id)
          : null;
        response.previous != "" && response.previous != "undefined"
          ? oPost.nextPostById(oPost.options.nextPostId)
          : false;
      })
      .fail(function (response) {
        console.log("Something went wrong...");
      });
  },

  nextPostById: function (postId) {
    $.ajax({
      method: "GET",
      url: oPost.routes.postById + postId,
      data: {
        scroll: "true",
        categories_exclude: "23",
      },
    })
      .done(function (response) {
        if (response != "" && response != "undefined") {
          oPost.createPost(response.id, response.link);
        }
      })
      .fail(function (response) {
        console.log("Something went wrong...");
      });
  },

  createPost: function (id, url) {
    $.ajax({
      url: url,
      cache: false,
      success: function (response) {
        var parsed = $.parseHTML(response),
          post = $(parsed).filter("#post__container__" + id),
          newPostContainer = $("<div>"),
          loaderInit = $("<div>"),
          commentContainer = $("<div>"),
          commentWrapper = $("<div>"),
          redirectForm = $("<form>");
        (commentLink = $("<button>")), (hiddenInput = $("<input>"));

        $(newPostContainer).addClass("post__container__" + id);

        $(newPostContainer).attr("id", "post__container__" + id);

        $(loaderInit).addClass("start-load").attr("post-id", id);

        $(commentContainer).addClass(
          "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 mb-8"
        );

        $(commentWrapper).addClass("grid grid-cols-3 slideToNextButton");
        $(redirectForm).addClass("block col-span-3 lg:col-span-2");

        // $(commentLink)
        //   .css("height", "80px")
        //   .css("width", "100%")
        //   .css("display", "block");
        // $(commentLink).addClass("redirectToComment");

        // $(commentLink).attr("type", "submit").text("ZOBACZ KOMENTARZE");

        $(hiddenInput)
          .attr("name", "redirect")
          .attr("value", url + "#disqus_thread")
          .attr("hidden", "hidden");

        $(commentContainer).append(commentWrapper);

        $(redirectForm).attr("method", "POST");
        $(commentWrapper).append(redirectForm);
        $(redirectForm).append(hiddenInput);

        $(newPostContainer)
          .append(post[0])
          .append(commentContainer)
          .append(loaderInit);

        $(oPost.sel.postsContainer).append(newPostContainer);

        $(newPostContainer).addClass("top__padding");

        oPost.urls[id] = url;
        oPost.sel.initPoint = '.start-load[post-id="' + id + '"]';
        oPost.options.currentPostId = id;
        oPost.options.firstQueryEnded = true;
        oPost.options.iterationCounter++;

        // Reinit modules
        oPreview.init();
      },
    });
  },
  checkViewport: function () {
    $(oPost.sel.postBody).each(function () {
      if (oPost.isInViewport(this)) {
        oPost.options.currentInViewport = this.getAttribute("post-data");

        var thisBind = this.getAttribute("post-data");

        if (oPost.options.currentInViewport != oPost.options.wasInViewport) {
          oPost.changeLink(oPost.urls[thisBind]);

          oPost.options.wasInViewport = this.getAttribute("post-data");
        }
      }
    });
  },
  isInViewport: function (post) {
    var win = $(window),
      viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft(),
      };

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = $(post).offset();
    bounds.right = bounds.left + $(post).outerWidth();
    bounds.bottom = bounds.top + $(post).outerHeight();

    return !(
      viewport.right < bounds.left ||
      viewport.left > bounds.right ||
      viewport.bottom < bounds.top ||
      viewport.top > bounds.bottom
    );
  },

  moveProgressBar: function (id) {
    var selector = "#post__container__" + id,
      scrollPercent =
        (100 * ($(window).scrollTop() - $(selector).offset().top)) /
        $(selector).height();

    $(oPost.sel.progressBar).css("width", Math.ceil(scrollPercent) + "%");
  },

  changeLink: function (url) {
    window.history.replaceState(null, null, url);
  },

  asyncFunction: function () {
    var deferred = $.Deferred();

    setTimeout(function () {
      deferred.resolve();

      deferred.reject();
    }, 1);

    return deferred;
  },
};

$(document).ready(function () {
  if ($("#mod").val() == "single-post" && $("#isPreview").val() != "true") {
    console.log("HERE!");
    oPost.init();
    oPreview.init();
  }
});
